"use client";

import { motion } from "framer-motion";
import { fadeInUp, staggerContainer } from "@/lib/animations";
import GlassCard from "@/components/ui/GlassCard";
import { Lightbulb, Users, Palette, Trophy } from "lucide-react";

const features = [
  {
    icon: Lightbulb,
    title: "Innovation Hub",
    description:
      "A space where creative minds collaborate and bring groundbreaking ideas to life.",
  },
  {
    icon: Users,
    title: "Community Driven",
    description:
      "Connect with like-minded designers, entrepreneurs, and industry professionals.",
  },
  {
    icon: Palette,
    title: "Creative Excellence",
    description:
      "Access world-class facilities and resources to elevate your creative projects.",
  },
  {
    icon: Trophy,
    title: "Growth & Success",
    description:
      "Participate in competitions, workshops, and events that advance your career.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8"
    >
      <div className="container mx-auto max-w-7xl">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {/* Section Header */}
          <motion.div
            variants={fadeInUp}
            className="text-center mb-12 sm:mb-16 lg:mb-20"
          >
            <h2 className="text-heading text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 px-4">
              What is idworks Hub?
            </h2>
            <p className="text-text text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed px-4">
              idworks Hub is a premier creative destination in KAFD, Riyadh. We
              are a cultural platform dedicated to empowering Saudi designers
              through exhibitions, workshops, competitions, and collaborative
              opportunities. Our mission is to foster innovation, creativity,
              and professional growth within the design community.
            </p>
          </motion.div>

          {/* Features Grid */}
          <motion.div
            variants={staggerContainer}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8"
          >
            {features.map((feature, index) => (
              <GlassCard key={index} className="p-6 sm:p-8">
                <div className="flex flex-col items-center text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-primary/10 flex items-center justify-center mb-5 sm:mb-6">
                    <feature.icon className="w-7 h-7 sm:w-8 sm:h-8 text-primary" />
                  </div>
                  <h3 className="text-heading text-lg sm:text-xl font-semibold mb-3 sm:mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-text text-sm sm:text-base leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </GlassCard>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
